import React from 'react'
import Sidebar from '../../components/Sidebar'
import Navbar from '../../components/Navbar'
import ManageClientComponent from '../../components/ManageClientComponent/ManageClientComponent'

const ManageClient = () => {
    return (
        <div>
            <div className='flex'>
                <div className='w-[15%]'>
                    <Sidebar />
                </div>
                <div>
                    <Navbar />
                    <ManageClientComponent />
                </div>
            </div>
        </div>
    )
}

export default ManageClient
